/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type Store from "@ember-data/store";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { task } from "ember-concurrency";
import type FileAttachment from "parog-web/models/file-attachment";

interface Signature {
  Args: {
    fileAttachment: FileAttachment;
    alternativeText: string;
    shouldDisplayDownloadLink?: boolean;
    shouldDisplayTextWithDownloadIcon?: boolean;
    downloadText?: string;
  };
}

export default class FileAttachmentDisplayer extends Component<Signature> {
  @service declare store: Store;

  get mimeType() {
    return this.args.fileAttachment.mimeType;
  }

  get fileAttachment() {
    return this.args.fileAttachment;
  }

  /**
   * Async loading of the file attachment content
   * into a variable, which will be used :
   * - to display an iFrame if the user is not on a mobile
   * - to allow user to download the file given its content and mimeType,
   *   because iFrame aren't supported on every mobile and browsers
   */
  retrieveDocumentContent = task(
    async (
      modifyDocumentContent: (documentContent: string | undefined) => void
    ) => {
      const fileContent = await this.fileAttachment.fileContent;
      modifyDocumentContent(fileContent.data);
    }
  );
}
